import React from "react";
import {Alert, Card, CardBody, Container} from "reactstrap";
import {inject, observer} from "mobx-react";

// L'outil (dualshock-tools, licence MIT) est installé dans public/calibration/ par scripts/update-calibration.sh.
const URL_OUTIL = process.env.PUBLIC_URL + "/calibration/index.html";

/**
 * Calibrage et test des manettes PlayStation (DualShock 4, DualSense) branchées en USB sur ce poste.
 * L'outil parle à la manette par WebHID : il faut Chrome, Edge ou Opera, et une page en HTTPS (ou localhost).
 */
const Calibration = (inject("rootStore")(observer(class Calibration extends React.Component {

    get injected() {
        return this.props;
    }

    constructor(props, context) {
        super(props, context);
        this.injected.rootStore.savedDatasStore.setHeader("Manettes", "Calibrer et tester une manette réparée", "default.jpg");
    }

    render() {
        const webHidDisponible = typeof navigator !== "undefined" && !!navigator.hid;

        return (
            <Container fluid>
                {!webHidDisponible && (
                    <Alert color="warning">
                        Ce navigateur ne sait pas parler aux manettes (WebHID). Ouvrez le tableau de bord avec Chrome,
                        Edge ou Opera, en HTTPS.
                    </Alert>
                )}
                <Card>
                    <CardBody className="p-0">
                        <iframe
                            title="Calibrage des manettes"
                            src={URL_OUTIL}
                            allow="hid"
                            style={{width: "100%", height: "calc(100vh - 230px)", minHeight: 600, border: 0}}
                        />
                    </CardBody>
                </Card>
            </Container>
        );
    }
})));

export default Calibration;
